import React from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';

const Mayor = ({ token, id_company }) => {
  const generarLibroMayor = async () => {
    try {
      console.log('el id de la empresa en Mayor.js es', id_company);
      const response = await axios.get(`${API_BASE_URL}/api/generar-libro-mayor`, {
        params: { id_company },
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(response.data); // Muestra el mensaje de éxito
    } catch (error) {
      console.error('Error al generar el libro mayor:', error);
      alert('Hubo un error al generar el libro mayor');
    }
  };
  return (
    <div>
      <h1>Libro Mayor</h1>
      <button onClick={generarLibroMayor}>Generar Libro Mayor</button>
    </div>
  );
};

export default Mayor;
